export default __webpack_public_path__ + "static/media/Q4_0_resized.ae2349dd.jpg";